// @ts-nocheck
let toasts = [];
let nextId = 1;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener([...toasts]));
}

export function getToasts() {
  return toasts;
}

export function subscribeToasts(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function addToast({ message, type = 'info', link = '', linkLabel = '', duration = 5000, key = '' }) {
  const id = String(nextId++);
  const nextToast = { id, message, type, link, linkLabel, duration, key };
  toasts = key ? toasts.filter((toast) => toast.key !== key) : toasts;
  toasts = [nextToast, ...toasts];
  notify();
  if (duration > 0) {
    setTimeout(() => removeToast(id), duration);
  }
  return id;
}

export function updateToast(id, partial) {
  toasts = toasts.map((toast) => (toast.id === id ? { ...toast, ...partial } : toast));
  notify();
  const updated = toasts.find((toast) => toast.id === id);
  if (updated?.duration > 0) {
    setTimeout(() => removeToast(id), updated.duration);
  }
}

export function removeToast(id) {
  toasts = toasts.filter((toast) => toast.id !== id);
  notify();
}

export function clearToasts() {
  toasts = [];
  notify();
}
